import client from "../api/client";
import type { DeliveryResult, EventTransport } from "./eventOutbox";
import type { ProductAnalyticsEvent } from "./eventTypes";
import { recordOperationalEvent } from "./operationalRuntime";

function responseStatus(error: unknown): number | undefined {
  return (error as { response?: { status?: number } })?.response?.status;
}

export const productEventTransport: EventTransport = {
  async send(event: ProductAnalyticsEvent): Promise<DeliveryResult> {
    void recordOperationalEvent({ event: "analytics_delivery_attempted", clientEventId: event.clientEventId });
    try {
      const response = await client.post("/api/sat/analytics/events", event);
      const eventId = response.data?.data?.eventId;
      if (typeof eventId !== "string") throw new Error("Analytics acknowledgement omitted eventId");
      void recordOperationalEvent({ event: "analytics_delivery_acknowledged", clientEventId: event.clientEventId });
      return { kind: "ack", clientEventId: event.clientEventId, eventId };
    } catch (error) {
      const status = responseStatus(error);
      if (status === 400 || status === 409 || status === 422) return { kind: "terminal" };
      throw error;
    }
  },
};
